import React from "react";
import styles from "./recordingIndicator.module.css";

export default function RecordingIndicator({ secondsRemaining }) {
  const progressDots = [];

  for (let i = 0; i < secondsRemaining; i++) {
    progressDots.push(
      <div key={i} className={styles.progressDot}>
        <div className={styles.dotInner} />
      </div>
    );
  }

  return <div className={styles.recordingIndicator}>{progressDots}</div>;
}
